import React from 'react';
import {IconComponent} from "../../reusable/simpleComponents";

interface Props {
    onClick: any
}

const TriggersIconUIComponent: React.FC<Props> = ({onClick}) => {
    return (
        <IconComponent classValue="triggers-icon pointer icon"
                       handler={onClick}
                       title="Camera Triggers"
        />
    );
};

export default TriggersIconUIComponent;